import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoggerService, Occ, OccEndpointsService, User, normalizeHttpError } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserCurrentAdapter } from './user-current.adapter';

@Injectable({
  providedIn: 'root',
})
export class OccUserCurrentAdapter implements UserCurrentAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  load(userId: string): Observable<User> {
    const url = this.occEndpoints.buildUrl('currentUser', { urlParams: { userId } });
    return this.http.get<Occ.User>(url).pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
